module.exports = __webpack_public_path__ + "static/media/use-case.428b9735.svg";